import { ReactNode } from 'react';
import {
  Box,
  Center,
  CenterProps,
  Flex,
  Paragraph,
  Spinner
} from '../../atoms';

type Props = {
  title?: string;
  description?: string;
  icon?: JSX.Element;
  footer?: ReactNode;
  body?: ReactNode;
  spinner?: boolean;
} & CenterProps;

export function FullScreenDialog({
  title,
  description,
  spinner,
  icon,
  footer,
  body,
  ...rest
}: Props): JSX.Element {
  return (
    <Center flexDirection="column" {...rest}>
      <Center flexDirection="column" h="full" p="32px">
        <Flex
          flexDirection="column"
          p="space_unit.x2"
          textAlign="center"
          align="center"
        >
          {spinner ? (
            <Spinner size="xl" color="#B210FF" thickness="4px" />
          ) : null}
          {icon ?? null}
          {title ? (
            <Paragraph pt="24px" pb="space_unit.x2" fontWeight={500}>
              {title}
            </Paragraph>
          ) : null}
          {description ? (
            <Paragraph color="palette_gray.70">{description}</Paragraph>
          ) : null}
        </Flex>
        <Flex w="full">{body ?? null}</Flex>
      </Center>

      <Box w="full" px="space_unit.x2">
        {footer ?? null}
      </Box>
    </Center>
  );
}
